import React, { useState, useRef, useEffect } from "react";
import {
    Button,
    Grid,
    IconButton,
    MenuItem,
    Paper,
    TextField,
    Typography,
    FormControl,
    InputLabel,
    Select,
    Checkbox,
    ListItemText,
    styled,
    Box,
    CircularProgress,
    Chip,
    Dialog,
    DialogContentText,
    DialogTitle,
    DialogContent,
    DialogActions,
    TableContainer,
    TableHead,
    Table,
    TableRow,
    TableCell,
    TableBody,
    useTheme,
    TablePagination,
} from "@material-ui/core";
import { Delete, Edit } from "@material-ui/icons";
import { DatePicker } from "@material-ui/pickers";
import { authorizationHeader, responseBody } from "util/fetchUtil";
import { TokenManager } from "util/TokenManager";
import { format } from "date-fns";
import { toast } from "react-toastify";
import { Autocomplete } from "@material-ui/lab";
import { set, template } from "lodash";
import { getEntityById, loadCompaniesList, loadEnitiesTemplate, loadEntityGet, updateEntity } from "./projectsApi";



export const Entities = () => {

    const [entity, setEntity] = useState([]);
    const [loadingEntity, setLoadingEntity] = useState(true);
    const [loadingCompanies, setLoadingCompanies] = useState(true);
    const [companies, setCompanies] = useState([]);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [openConfirmTemplateDialog, setOpenConfirmtemplateDialog] = useState(false);
    const [openEditEntityDialog, setOpenEditEntityDialog] = useState(false);
    const [selectedTemplateId, setSelectedTemplateId] = useState(null);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [Template, setTemplate] = useState([]);
    const [isCallEntity, setIsCallEntity] = useState(false);
    const [errors, setErrors] = useState({});
    const [hoveredItemId, setHoveredItemId] = useState(null);

    const [EntityEdit, setEntityEdit] = useState({ results: [], count: 0 });
    const [loading, setLoading] = useState(false);
    const [editEntityId, setEditEntityId] = useState(0);
    const [editEntityData, setEditEntityData] = useState(null);
    const [editEntityFlag, setEditEntityFlag] = useState(false);
    const [EntityExpanedFlag, setEntityExpanedFlag] = useState(false);
    const [filterTrigger, setFilterTrigger] = useState(0);

    const [filters, setFilters] = useState({
        companyName: "",
        companyType: "",

    });


    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const theme = useTheme();

    const fetchEntity = async (page, limit) => {
        try {
            setLoading(true);

            const response = await loadEntityGet(page, limit, filters);

            setEntityEdit(response);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };



    useEffect(() => {
        fetchEntity(page, rowsPerPage);
    }, [page, rowsPerPage, filterTrigger]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };


    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(rowsPerPage); // reset to first page
    };

    //call the API to get the list of entities
    const handleLoadEntity = async () => {
        try {
            const fetchedEntity = await loadEnitiesTemplate();
            setEntity(fetchedEntity);
            setLoadingEntity(false);
        } catch (error) {
            console.error("Error fetching entity :", error);
            setLoadingEntity(false);
        }
    }

    const handleLoadCompany = async () => {
        try {
            const fetchedCompany = await loadCompaniesList();
            setCompanies(fetchedCompany);
            setLoadingCompanies(false); // Set loading to false once data is fetched
        } catch (error) {
            console.error("Error fetching companies", error);
            setLoadingCompanies(false); // Even on error, stop loading
        }
    }

    const initialFormValues = {
        template: "",
        template_title: "",
        company: "",
        legal_name: "",
        display_name: "",
        isPublic: "false",
        type: "",
        company_type: "",
        website: "",
        country: "",
        template_id: null,
    };
    const [formValues, setFormValues] = useState(initialFormValues);

    const type = [
        { value: "PARTNER", label: "Downstream Partner" },
        { value: "CLIENT", label: "Downstream Client" },
        { value: "MANUFACTURER", label: "Manufacturer" },
        { value: "PVEL", label: "PVEL" },
    ];
    const companyType = [
        { value: "DEV", label: "Developer (Developer, EPC, Installer, O+M Provider)" },
        { value: "INV", label: "Investor(Investor, Finance Institution)" },
        { value: "MFG", label: "Manufacturer" },
        { value: "OWN", label: "Owner (IPP,Public Utility Company)" },
        { value: "EPC", label: "Engineering, Procurement and Construction (EPC) Company" },
        { value: "IE", label: "Engineering, Procurement and Construction (EPC) Contractor" },
        { value: "IPP", label: "Independent Power Producer" },
        { value: "SUP", label: "Supplier" },
    ];

    const clearForm = () => {
        setFormValues(initialFormValues);
        setEditEntityId(0);
        setEditEntityData(null);
        setEditEntityFlag(false);

    };

    const handleFilterSearch = () => {
        setPage(0);
        setFilterTrigger(t => t + 1);
    };

    const handleClearFilters = () => {
        setFilters({
            companyName: "",
            companyType: "",

        });
        setPage(0);
        setFilterTrigger(t => t + 1);
    };

    const handleSubmitEntity = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        const formData = new FormData();
        formData.append("template_title", formValues.template_title);
        formData.append("company", formValues.company);
        formData.append("legal_name", formValues.legal_name);
        formData.append("display_name", formValues.display_name);
        formData.append("public", formValues.isPublic);
        formData.append("type", formValues.type);
        formData.append("company_type", formValues.company_type);
        formData.append("website", formValues.website);
        formData.append("country", formValues.country);
        try {
            // const response = await fetch(
            //     "https://portolaprod.azurewebsites.net/api/entities/",
            //     {
            //         method: "POST",
            //         headers: {
            //             Authorization: authorizationHeader(TokenManager.getToken()),
            //         },
            //         body: formData,
            //     }
            // );
            const response = await fetch(
                "https://portolaprod.azurewebsites.net/api/entities/",
                {
                    method: "POST",
                    headers: {
                        Authorization: authorizationHeader(TokenManager.getToken()),
                    },
                    body: formData,
                }
            );

            if (!response.ok) {
                toast.error("Entity creation failed Please note that the Legal Name have already been used");
            } else {
                setOpenConfirmDialog(true);
                toast.success("Entity created successfully.",
                    //     {
                    //     onClose: () => window.location.reload(),
                    //     autoClose: 3000, // optional
                    // }
                );
            }
        } catch (err) {
            console.error("Error creating Entity:", err);
            toast.error(err.message);
        }

    }


    const handleDeleteTemplate = async (id) => {
        try {
            // const response = await fetch(`https://portolaprod.azurewebsites.net/api/entity_template/${id}/`, {
            //     method: 'PATCH',
            //     headers: {
            //         'Content-Type': 'application/json',
            //         Authorization: authorizationHeader(TokenManager.getToken()),
            //     },
            //     body: JSON.stringify({ active: false }),
            // });

            const response = await fetch(`https://portolaprod.azurewebsites.net/api/entity_template/${id}/`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: authorizationHeader(TokenManager.getToken()),
                },
                body: JSON.stringify({ active: false }),
            });

            if (response.ok) {
                console.log(`Template with ID ${id} deactivated successfully.`);
                toast.success("Template marked as inactive.");
                setEntity((prevTemplate) => ({
                    ...prevTemplate,
                    results: prevTemplate.results.filter((item) => item.id !== id),
                }));
                clearForm();
            } else {
                console.error('Patch failed:', await response.text());
                toast.error("Failed to update the template.");
            }
        } catch (error) {
            console.error('Error updating template:', error);
            toast.error("Something went wrong.");
        }
    };

    const handleEntityChange = async (e) => {
        await handleLoadCompany();

        const selectedUrl = e.target.value;

        const selectedEntity = entity.results.find(item => item.url === selectedUrl);

        setFormValues((prev) => ({
            ...prev,
            template: selectedUrl,
            template_id: selectedEntity?.id || null,
        }));

        try {
            const response = await fetch(selectedUrl, {
                method: "GET",
                headers: {
                    Authorization: authorizationHeader(TokenManager.getToken()),
                },
            });

            if (!response.ok) throw new Error("Failed to fetch template details");

            const data = await response.json();
            setFormValues((prev) => ({
                ...prev,
                template_title: data.template_title || prev.template_title,
                company: data.company || prev.company,
                legal_name: data.legal_name || prev.legal_name,
                display_name: data.display_name || prev.display_name,
                isPublic: data.public || prev.isPublic,
                type: data.type || prev.type,
                company_type: data.company_type || prev.company_type,
                website: data.website || prev.website,
                country: data.country || prev.country,

            }));
        } catch (err) {
            console.error("Error fetching selected template data:", err);
            toast.error("Failed to load template details.");
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues((prev) => ({ ...prev, [name]: value }));
    };


    const handleSaveTemplate = async (e, shouldSubmitEntityAfter = false) => {
        e.preventDefault();
        if (!validateForm()) return;
        const formData = new FormData();
        formData.append("template_title", formValues.template_title);
        formData.append("company", formValues.company);
        formData.append("type", formValues.type);
        formData.append("company_type", formValues.company_type);
        formData.append("legal_name", formValues.legal_name);
        formData.append("display_name", formValues.display_name);
        formData.append("website", formValues.website);
        formData.append("country", formValues.country);
        formData.append("public", formValues.isPublic);

        try {
            // const response = await fetch(
            //     `https://portolaprod.azurewebsites.net/api/entity_template/${formValues.template_id}/`,
            //     {
            //         method: "PUT",
            //         headers: {
            //             Authorization: authorizationHeader(TokenManager.getToken()),
            //         },
            //         body: formData,
            //     }
            // );

            const response = await fetch(
                `https://portolaprod.azurewebsites.net/api/entity_template/${formValues.template_id}/`,
                {
                    method: "PUT",
                    headers: {
                        Authorization: authorizationHeader(TokenManager.getToken()),
                    },
                    body: formData,
                }
            );

            if (!response.ok) {
                toast.error("Template creation failed Please note that the Template and Legal Name have already been used");
            } else {


                if (shouldSubmitEntityAfter) {
                    handleSubmitEntity(e);
                }
                toast.success("Template created successfully.", {
                    onClose: () => window.location.reload(),
                    autoClose: 3000, // optional
                });
                clearForm();

            }
        } catch (err) {
            console.error("Error creating template:", err);
            toast.error(err.message);
        }
        //   window.location.reload();
    };

    const handleSubmitTemplate = async (e, shouldSubmitEntityAfter = false) => {
        e.preventDefault();
        if (!validateForm(true)) return;
        const formData = new FormData();
        formData.append("template_title", formValues.template_title);
        formData.append("company", formValues.company);
        formData.append("type", formValues.type);
        formData.append("company_type", formValues.company_type);
        formData.append("legal_name", formValues.legal_name);
        formData.append("display_name", formValues.display_name);
        formData.append("website", formValues.website);
        formData.append("country", formValues.country);
        formData.append("public", formValues.isPublic);

        try {
            // const response = await fetch(
            //     "https://portolaprod.azurewebsites.net/api/entity_template/",
            //     {
            //         method: "POST",
            //         headers: {
            //             Authorization: authorizationHeader(TokenManager.getToken()),
            //         },
            //         body: formData,
            //     }
            // );
            const response = await fetch(
                "https://portolaprod.azurewebsites.net/api/entity_template/",
                {
                    method: "POST",
                    headers: {
                        Authorization: authorizationHeader(TokenManager.getToken()),
                    },
                    body: formData,
                }
            );

            if (!response.ok) {
                toast.error("Template creation failed Please note that the Template and Legal Name have already been used");
            } else {


                // if (shouldSubmitEntityAfter) {
                //     handleSubmitEntity(e);
                // }
                setOpenConfirmtemplateDialog(true);
                toast.success("Template created successfully.",
                    // {
                    //     onClose: () => window.location.reload(),
                    //     autoClose: 3000, // optional
                    // }
                );
                clearForm();

            }
        } catch (err) {
            console.error("Error creating template:", err);
            toast.error(err.message);
        }
        //   window.location.reload();
    };

    const handleEditEntity = async (id) => {

        setEditEntityId(id);
        await handleLoadCompany();

        setEditEntityFlag(true);

        console.log("entity with ID:", id);
        try {
            const data = await getEntityById(id);
            setEditEntityData(data);
            console.info("log", data);

            setFormValues((prev) => ({
                ...prev,
                template_title: data.template_title || prev.template_title,
                company: data.company || prev.company,
                legal_name: data.legal_name || prev.legal_name,
                display_name: data.display_name || prev.display_name,
                isPublic: data.public || prev.isPublic,
                type: data.type || prev.type,
                company_type: data.company_type || prev.company_type,
                website: data.website || prev.website,
                country: data.country || prev.country,

            }));


        } catch (err) {

            console.error("Submission error:", err);
            toast.error("Entity creation failed.", err);
        }



    };

    const handleUpdate = async () => {
        console.info("edit form values", formValues)

        if (!validateForm()) {
            toast.error("Please fill out all required fields.");
            return;
        }

        const formData = new FormData();

        formData.append("company", formValues.company);
        formData.append("legal_name", formValues.legal_name);
        formData.append("display_name", formValues.display_name);
        formData.append("public", formValues.isPublic);
        formData.append("type", formValues.type);
        formData.append("company_type", formValues.company_type);
        formData.append("website", formValues.website);
        formData.append("country", formValues.country);
        formData.append("entity_id", editEntityId.toString());

        try {
            const response = await updateEntity(formData);

            if (response.ok) {
                setOpenEditEntityDialog(true)
                toast.success("Entity Updated successfully.",
                    //   {
                    //   onClose: () => window.location.reload(),
                    //   autoClose: 3000,
                    // }
                );
                clearForm()
            } else {
                const errorText = await response.text();
                console.error("Submission failed:", errorText);
                toast.error(`Failed to update entity: ${errorText}`);
            }
        } catch (err) {
            // console.log("customer id", customerIds);
            console.error("Submission error:", err);
            toast.error("Entity creation failed.", err);
        }
    }

    const validateForm = (requireTemplateTitle = false) => {
        const newErrors = {};

        if (requireTemplateTitle && !formValues.template_title?.trim()) {
            newErrors.template_title = ['Template Title is required'];
        }

        if (!formValues.company) {
            newErrors.company = ['Company is required'];
        }

        if (!formValues.type) {
            newErrors.type = ['Type is required'];
        }

        if (!formValues.company_type) {
            newErrors.company_type = ['Company Type is required'];
        }

        if (!formValues.legal_name?.trim()) {
            newErrors.legal_name = ['Legal Name is required'];
        }
        if (!formValues.display_name?.trim()) {
            newErrors.display_name = ['Display Name is required'];
        }
        if (!formValues.website?.trim()) {
            newErrors.website = ['Website is required'];
        }
        if (!formValues.country?.trim()) {
            newErrors.country = ['Country is required'];
        }

        // Add more validations as needed...

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };





    return (
        <>
            <Paper>
                <Box px={5} py={4}>
                    <form onSubmit={handleSubmitEntity}>
                        <Grid item xs={12} style={{ padding: 40 }}>
                            <Box display="flex" justifyContent="flex-end">
                                {editEntityFlag ? null : (
                                    <FormControl style={{ minWidth: 400 }}>
                                        <InputLabel id="type-label">Template</InputLabel>

                                        <Select
                                            labelId="Template-label"
                                            name="template"
                                            placeholder="Select template"
                                            value={formValues.template}
                                            disabled={editEntityFlag}
                                            onOpen={handleLoadEntity}
                                            onChange={handleEntityChange}

                                        >
                                            {loadingEntity ? (
                                                <MenuItem value="">Loading...</MenuItem>
                                            ) : (
                                                entity.results.map((option) => (
                                                    <MenuItem
                                                        key={option.id}
                                                        value={option.url}
                                                        onMouseEnter={() => setHoveredItemId(option.id)}
                                                        onMouseLeave={() => setHoveredItemId(null)}
                                                    >
                                                        <Box
                                                            display="flex"
                                                            justifyContent="space-between"
                                                            alignItems="center"
                                                            width="100%"
                                                        >
                                                            <span>{option.template_title}</span>

                                                            {hoveredItemId === option.id && (
                                                                <Delete
                                                                    fontSize="small"
                                                                    sx={{ color: 'red', cursor: 'pointer' }}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        setSelectedTemplateId(option.id);
                                                                        setOpenDeleteDialog(true);
                                                                    }}
                                                                />
                                                            )}
                                                        </Box>
                                                    </MenuItem>
                                                )
                                                ))}
                                        </Select>
                                    </FormControl>
                                )

                                }

                            </Box>
                        </Grid>
                        <Grid container spacing={2} style={{ padding: 40 }}>

                            <Grid item xs={6}>
                                {editEntityFlag ? null : (

                                    <TextField
                                        fullWidth
                                        name="template_title"
                                        label="Template Title"
                                        placeholder="Enter template title"
                                        disabled={editEntityFlag}
                                        value={formValues.template_title}

                                        onChange={handleChange}

                                        error={!!errors.template_title}
                                        helperText={errors.template_title ? errors.template_title[0] : ""}
                                    />

                                )}
                            </Grid>



                            <Grid item xs={6}>
                                <Autocomplete
                                    fullWidth
                                    options={companies?.results || []}
                                    getOptionLabel={(option) => option.name || ""}
                                    loading={loadingCompanies}
                                    onOpen={handleLoadCompany}
                                    value={
                                        companies?.results?.find((e) => e.url === formValues.company) ||
                                        null
                                    }

                                    onChange={(event, newValue) => {
                                        handleChange({
                                            target: {
                                                name: "company",
                                                value: newValue ? newValue.url : "",
                                            },
                                        });
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Company"
                                            placeholder="Select company"
                                            error={!!errors.company}
                                            helperText={errors.company ? errors.company[0] : ""}
                                        />
                                    )}
                                    isOptionEqualToValue={(option, value) => option.url === value.url}
                                />
                            </Grid>

                            <Grid item xs={6}>

                                <Autocomplete
                                    fullWidth
                                    options={type}
                                    getOptionLabel={(option) => option.label}
                                    value={
                                        type.find(
                                            (opt) => opt.value === formValues.type
                                        ) || null
                                    }
                                    onChange={(event, newValue) => {
                                        handleChange({
                                            target: {
                                                name: "type",
                                                value: newValue ? newValue.value : "",
                                            },
                                        });
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Type"
                                            placeholder="Select type"
                                            error={!!errors.type}
                                            helperText={errors.type ? errors.type[0] : ""}
                                        />
                                    )}
                                    isOptionEqualToValue={(option, value) =>
                                        option.value === value.value
                                    }
                                />
                            </Grid>

                            <Grid item xs={6}>
                                <Autocomplete
                                    fullWidth
                                    options={companyType}
                                    getOptionLabel={(option) => option.label}
                                    value={
                                        companyType.find(
                                            (opt) => opt.value === formValues.company_type
                                        ) || null
                                    }
                                    onChange={(event, newValue) => {
                                        handleChange({
                                            target: {
                                                name: "company_type",
                                                value: newValue ? newValue.value : "",
                                            },
                                        });
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Company Type"
                                            placeholder="Select company type"
                                            error={!!errors.company_type}
                                            helperText={errors.company_type ? errors.company_type[0] : ""}
                                        />
                                    )}
                                    isOptionEqualToValue={(option, value) =>
                                        option.value === value.value
                                    }
                                />

                            </Grid>

                            <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    name="legal_name"
                                    label="legal Name"
                                    placeholder="Enter legal name"
                                    value={formValues.legal_name}
                                    onChange={handleChange}
                                    error={!!errors.legal_name}
                                    helperText={errors.legal_name ? errors.legal_name[0] : ""}
                                />
                            </Grid>

                            <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    name="display_name"
                                    label="Display Name"
                                    placeholder="Enter display name"
                                    value={formValues.display_name}
                                    onChange={handleChange}
                                    error={!!errors.display_name}
                                    helperText={errors.display_name ? errors.display_name[0] : ""}
                                />
                            </Grid>

                            <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    name="website"
                                    label="Website"
                                    placeholder="Enter website"
                                    value={formValues.website}
                                    onChange={handleChange}
                                    error={!!errors.website}
                                    helperText={errors.website ? errors.website[0] : ""}
                                />
                            </Grid>

                            <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    name="country"
                                    label="Country"
                                    placeholder="Enter country"
                                    value={formValues.country}
                                    onChange={handleChange}
                                    error={!!errors.country}
                                    helperText={errors.country ? errors.country[0] : ""}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth>
                                    <InputLabel id="isPublic-label">Is Public</InputLabel>
                                    <Select
                                        labelId="isPublic-label"
                                        name="isPublic"
                                        value={formValues.isPublic}
                                        onChange={handleChange}
                                    >
                                        <MenuItem value="false">No</MenuItem>
                                        <MenuItem value="true">Yes</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} style={{ marginBottom: 40 }}>
                            <Box display="flex" justifyContent="center" mt={2}>
                                <Button
                                    type="button"
                                    variant="contained"
                                    color="primary"
                                    style={{ marginRight: 10 }}
                                    onClick={editEntityFlag ? handleUpdate : handleSubmitEntity}
                                >
                                    {editEntityFlag ? "Update Entity" : "Submit entity"}
                                </Button>

                                <Button
                                    type="button"
                                    variant="contained"
                                    color="primary"
                                    style={{ marginLeft: 10 }}
                                    disabled={editEntityFlag}
                                    onClick={(e) => {
                                        handleSubmitTemplate(e, false);
                                    }}
                                >
                                    Save As Template
                                </Button>
                                <Button
                                    type="button"
                                    variant="contained"
                                    color="primary"
                                    style={{ marginLeft: 10 }}
                                    onClick={clearForm}
                                >
                                    Clear
                                </Button>
                            </Box>
                        </Grid>

                    </form>
                </Box>




                <Dialog
                    open={openConfirmDialog}
                    onClose={() => setOpenConfirmDialog(false)}
                >
                    <DialogTitle>Confirmation status</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            The Entity has been submitted successfully.

                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={(e) => {
                                setOpenConfirmDialog(false);
                                window.location.reload();
                            }}
                            color="secondary"
                        >
                            ok
                        </Button>

                    </DialogActions>
                </Dialog>

                <Dialog
                    open={openConfirmTemplateDialog}
                    onClose={() => setOpenConfirmtemplateDialog(false)}
                >
                    <DialogTitle>Confirmation status</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            The Entity has been successfully saved as a template.

                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={(e) => {
                                setOpenConfirmtemplateDialog(false);
                                window.location.reload();
                            }}
                            color="secondary"
                        >
                            ok
                        </Button>

                    </DialogActions>
                </Dialog>

                <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
                    <DialogTitle>Delete Template</DialogTitle>
                    <DialogContent>Are you sure you want to delete this template?</DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpenDeleteDialog(false)} color="secondary">Cancel</Button>
                        <Button
                            onClick={() => {
                                handleDeleteTemplate(selectedTemplateId);
                                setOpenDeleteDialog(false);
                            }}
                            color="primary"
                            variant="contained"
                        >
                            Delete
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={openEditEntityDialog}
                    onClose={() => setOpenEditEntityDialog(false)}
                >
                    <DialogTitle>Confirmation status</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            The Entity has been Updated successfully .

                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={(e) => {
                                setOpenEditEntityDialog(false);
                                window.location.reload();
                            }}
                            color="secondary"
                        >
                            ok
                        </Button>

                    </DialogActions>
                </Dialog>

            </Paper>

            <Grid container spacing={2} style={{ alignItems: "center", justifyContent: "center" }}>
                <Grid item style={{ marginTop: "20px" }}>
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={() => {
                            clearForm();
                            setEntityExpanedFlag(!EntityExpanedFlag);

                        }}

                    >
                        Update Entity Informtion
                    </Button>
                </Grid>
            </Grid >
            {EntityExpanedFlag && (
                <>
                    <Grid container spacing={2} style={{ margin: "10px" }}>
                        <Grid item xs={12} sm={6} md={3}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                label="Company Name"
                                size="small"
                                value={filters.companyName}
                                onChange={(e) =>
                                    setFilters({ ...filters, companyName: e.target.value })
                                }
                            />
                        </Grid>

                        





                        {/* Buttons */}
                        <Grid item xs={12} sm={6} md={2}>
                            <Button
                                fullWidth
                                variant="contained"
                                color="primary"
                                onClick={handleFilterSearch}
                            >
                                Search
                            </Button>
                        </Grid>

                        <Grid item xs={12} sm={6} md={2}>
                            <Button
                                fullWidth
                                variant="contained"
                                
                                onClick={handleClearFilters}
                            >
                                Clear
                            </Button>
                        </Grid>
                    </Grid>
                    <Paper style={{ margin: "20px 10px" }}>


                        <TableContainer style={{ height: "1000px" }}>
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow style={theme.tableHeaderRow}>

                                        <TableCell style={theme.tableHeader}>Company Name</TableCell>
                                        <TableCell style={theme.tableHeader}>Company Type</TableCell>
                                        <TableCell style={theme.tableHeader}>Type</TableCell>
                                        <TableCell style={theme.tableHeader}>country</TableCell>
                                        <TableCell style={theme.tableHeader}>Edit</TableCell>

                                    </TableRow>
                                </TableHead>

                                {loading ? (
                                    <TableBody>
                                        <TableRow>
                                            <TableCell colSpan={8}>
                                                <Box display="flex" justifyContent="center" p={4}>
                                                    <CircularProgress />
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                ) : (
                                    <TableBody>
                                        {EntityEdit.results.map((entity) => (
                                            <TableRow key={entity.id}>
                                                <TableCell>{entity.display_name || "N/A"}</TableCell>
                                                <TableCell>{entity.company_type || "N/A"}</TableCell>
                                                <TableCell>{entity.type || "N/A"}</TableCell>

                                                <TableCell>{entity.country || "N/A"}</TableCell>

                                                <TableCell>
                                                    <IconButton
                                                        onClick={() => {
                                                            clearForm();
                                                            handleEditEntity(entity.id)
                                                        }}
                                                    >
                                                        <Edit />
                                                    </IconButton>
                                                </TableCell>

                                            </TableRow>
                                        ))}
                                    </TableBody>
                                )}
                            </Table>
                        </TableContainer>

                        <TablePagination
                            rowsPerPageOptions={[]}
                            component="div"
                            count={EntityEdit.count || 0}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            labelRowsPerPage=""
                        />
                    </Paper>

                </>
            )
            }
        </>

    )
}